import { useState } from "react";
import type { ShopifyOrderSkipReason, ShopifyOrderView } from "../../api/types";
import { ReasonModal } from "../ui/ReasonModal";
import { SKIP_REASON_LABEL } from "./webOrderAttention";

const REASONS: ShopifyOrderSkipReason[] = [
  "MADE_OUTSIDE_CRM",
  "CANCELLED_WITH_CUSTOMER",
  "DUPLICATE",
  "TEST",
  "OTHER",
];

/**
 * G-160 (OD-265) — an owner skips a web order nobody accepted. The reason is
 * one of five; the note is optional except for "Other". The server refuses
 * the same things, so a race with a shop accepting is answered there.
 */
export function SkipWebOrderModal({
  order,
  busy,
  error,
  onConfirm,
  onClose,
}: {
  order: ShopifyOrderView;
  busy: boolean;
  error: string | null;
  onConfirm: (reason: ShopifyOrderSkipReason, note: string | undefined) => void;
  onClose: () => void;
}) {
  const [reason, setReason] = useState<ShopifyOrderSkipReason>("MADE_OUTSIDE_CRM");
  return (
    <ReasonModal
      title={`Skip web order ${order.orderNumber ?? order.shopifyOrderId}?`}
      reasonMode={reason === "OTHER" ? "required" : "optional"}
      reasonLabel="Note"
      confirmLabel="Skip order"
      cancelLabel="Keep it"
      busy={busy}
      error={error}
      onConfirm={(note) => onConfirm(reason, note)}
      onClose={onClose}
    >
      <fieldset className="wo-skip-reasons">
        <legend>Reason</legend>
        {REASONS.map((value) => (
          <label key={value} className={value === reason ? "wo-skip-option is-selected" : "wo-skip-option"}>
            <input
              type="radio"
              name="skip-reason"
              value={value}
              checked={value === reason}
              onChange={() => setReason(value)}
            />
            {SKIP_REASON_LABEL[value]}
          </label>
        ))}
      </fieldset>
    </ReasonModal>
  );
}
